module.exports = __webpack_public_path__ + "img/pdf.dd6d9211.svg";